define([
	'jquery',
	'routes/helper',
	'components/consumerweb-client-error-logger/historyModel',
	'routes/tables/summary-table'
], function ($, SubRouteHelper, historyModel, SummaryRouteTable) {

	'use strict';

	return SubRouteHelper.extend({

		/**
		 * Register all the interesting URIs that will fire off generic or specific functionality
		 */
		routes: SummaryRouteTable.backbone,

		/**
		 * Main summary route
		 */
		showSummary: function () {
			this.showView({
				name: 'summary/index'
			});
			this.cleanView();
		},

		/**
		 *	Load summary route
		 *	closes notification modal because we don't want a modal on top of another
		 *  @param action - wallet route's action
		 *	@param fn - callback function
		 */
		loadSummaryRoute: function (action, fn) {
			this.showView({
				name: 'summary/index',
				callback: function () {
					var $notificationModal = $('#notificationModal');

					if ($notificationModal) {
						$notificationModal.modal('hide');
					}

					fn();
				}
			});

			historyModel.addPath('summary/' + action);
		},

		/**
		 *	Show confirm email callback
		 */
		showConfirmEmail: function () {
			this.view.openConfirmEmail('home');
		},

		/**
		 *	Show confirmEmail route
		 */
		confirmEmail: function () {
			this.loadSummaryRoute('confirmEmail', this.showConfirmEmail.bind(this));
		},
		/**
		 *	Show add funds flow callback
		 */
		showAddFunds: function () {
			this.view.checkCIPStatus();
		},

		/**
		 *	Show add funds flow route
		 */
		addFunds: function () {
			this.loadSummaryRoute('addFunds', this.showAddFunds.bind(this));
		},

		showRepayBalance: function() {
			this.view.skipCIP();
		},

		repayBalance: function () {
			this.loadSummaryRoute('repayFunds', this.showRepayBalance.bind(this));
		},

		/**
		 *	Add address callback
		 *	@param returnUrl - url to return to
		 */
		showAddAddress: function (returnUrl) {
			this.view.addAddress(returnUrl);
		},

		/**
		 *	Add address route
		 *	@param returnUrl - url to return to
		 */
		addAddress: function (returnUrl) {
			this.loadSummaryRoute('add/address', this.showAddAddress.bind(this, returnUrl));
		},

		/**
		* Add Goal Info callback
		*/
		openAddGoalInfo: function () {
			this.view.openAddGoalInfo();
		},

		/**
		* Add Goal Info Route
		*/
		addGoal: function() {
			this.loadSummaryRoute('addGoal', this.openAddGoalInfo.bind(this));
		},

		/* Show Goal Details callback
		* @param goalId - the id of the goal
		*/
		showGoalDetails: function (goalId, showGoalDetailsAfterGoalReached) {
			this.view.showGoalDetails(goalId, showGoalDetailsAfterGoalReached);
		},

		/**
		* Show Goal Details route
		* @param goalId - the id of the goal
		*/
		goalDetails: function (goalId, showGoalDetailsAfterGoalReached) {
			this.loadSummaryRoute('goal', this.showGoalDetails.bind(this, goalId, showGoalDetailsAfterGoalReached));
		},

		/**
		 * Show Withdrawal limits steps
		 */
		showWithdrawalLimitsSteps: function () {
			this.view.showWithdrawalLimitsSteps();
		},

		/**
		 * Withdrawal limits steps route
		 */
		liftWithdrawalLimits: function () {
			this.loadSummaryRoute('withdrawLimits', this.showWithdrawalLimitsSteps.bind(this));
		}
	});

});



//////////////////
// WEBPACK FOOTER
// ./routes/summary.js
// module id = 866
// module chunks = 0